import React from 'react';
import styles from './OrderBookFilter.module.scss';
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import moment from 'moment';
import PropTypes from 'prop-types';
import { CheckBox, TextBox, SelectBox } from 'devextreme-react';
import List from 'devextreme-react/list';
import { isEmpty } from '../../util/functions';
import { datePattern, timePattern } from '../../util/constants';


const systemTypes = [
  { id: 'ECN', value: 'ECN' },
  { id: 'IDQS', value: 'IDQS' },
  { id: 'OVERNIGHT', value: 'Night OTC' },
  { id: 'MOON', value: 'NMS' }
];

const initialState = {
  symbol: '',
  systemType: 'ECN'
};


const disableAutoComplete = {
  autocomplete: 'off'
};

class OrderBookFilter extends React.Component {
  constructor(props) {
    const localStorageSearch = window.localStorage.getItem('recentOrderBookSearch');
    const recentSearches = localStorageSearch && JSON.parse(localStorageSearch);
    super(props);
    this.state = {
      ...initialState,
      errorMessages: [],
      collapseOnSearch: window.localStorage.getItem('tps_collapseSearch') === 'true',
      showFilter: true,
      recentSymbolSearch: recentSearches && recentSearches.symbol
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getOrderDataFilterAttributes = this.getOrderDataFilterAttributes.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRecentSearches = this.handleRecentSearches.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDataLoaded !== this.props.isDataLoaded) {
      if (this.props.isDataLoaded && this.state.collapseOnSearch) {
        this.setState({ showFilter: false });
      }
    }
  }

  toggleFilter = () => this.setState(state => ({ showFilter: !state.showFilter }));

  handleListItemClick = (e, name) => {
    this.setState({
      isSymbolFocus: false,
      [name]: e.itemData
    });
  }

  showToolTip = label => {
    this.setState({
      [label]: true
    });
  }

  hideToolTip = label => {
    this.setState({
      [label]: false
    });
  }

  handleChange(event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch() {
    this.handleSubmit('search');
  }

  handleDownload() {
    this.handleSubmit('download');
  }

  handleSubmit(type) {
    let queryParam = this.state;
    //  console.log(queryParam);
    var errorMessages = [];
    if (isEmpty(queryParam['symbol'])) {
      errorMessages.push('Please select Symbol');
    }

    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      // put recent searches in the localstorage
      this.handleRecentSearches(queryParam);
      // try to get data
      let params = this.getOrderDataFilterAttributes(queryParam);
      this.props.search(params, type);
    }
  }

  handleRecentSearches(params) {
    const recentSearchStorage = window.localStorage.getItem('recentOrderBookSearch');

    let recentSearchData = {
      symbol: []
    };

    if (recentSearchStorage) {
      recentSearchData.symbol = JSON.parse(recentSearchStorage).symbol;
    }

    const symbolField = params.symbol && params.symbol.toUpperCase();
    if (symbolField && symbolField !== '') {
      if (!recentSearchData.symbol.includes(symbolField)) recentSearchData.symbol.unshift(symbolField);

      if (recentSearchData.symbol.includes(symbolField)) {
        const symbolArray = recentSearchData.symbol;
        const index = symbolArray.indexOf(symbolField);
        symbolArray.splice(index, 1);
        symbolArray.unshift(symbolField);
      }
    }
    if (recentSearchData.symbol.length > 10) recentSearchData.symbol.pop();


    window.localStorage.setItem('recentOrderBookSearch', JSON.stringify(recentSearchData));

    this.setState({
      isSymbolFocus: false,
      recentSymbolSearch: recentSearchData.symbol,
    });
  }

  renderErrorMessages() {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  getOrderDataFilterAttributes(queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if (key.toLowerCase().includes('date') && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (key.toLowerCase().includes('time') && moment.isDate(val)) {
          params[key] = moment(val).format(timePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });

    return params;
  }

  handleFocusIn(field) {
    this.setState({ [field]: true });
  }
  handleFocusOut(field) {
    setTimeout(() => { this.setState({ [field]: false }); }, 250);
  }

  handleCollapseOption = () => {
    this.setState(state => ({ collapseOnSearch: !state.collapseOnSearch }), () => window.localStorage.setItem('tps_collapseSearch', this.state.collapseOnSearch));
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false
      });

      this.handleSubmit('search');
    };
  }

  render() {
    const { recentSymbolSearch } = this.state;
    const isSymbolFocus = this.state.isSymbolFocus && recentSymbolSearch;
    const isFilterOpen = this.state.showFilter;
    return (
      <div id='OrderBookFilter' className={styles.container}>
        <div className={styles.formContainer}>

          {isFilterOpen && <div className={styles.orderGridStyle} onKeyDown={this.handleKeyDown}>

          <div key={'systemTypeKey'}>
              <Label title='System' />
              <SelectBox id={'systemType'}
                dataSource={systemTypes}
                placeholder={'System'}
                value={this.state['systemType']}
                displayExpr='value'
                valueExpr='id'
                name={'systemType'}
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'systemType')} /></div>

            <div key={'symbolKey'}>
              <Label title='Symbol' />
              <TextBox
                name={'symbol'} placeholder={'Symbol'} value={this.state['symbol']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isSymbolFocus')}
                onFocusOut={() => this.handleFocusOut('isSymbolFocus')}
                onValueChanged={(e) => this.handleChange(e, 'symbol')} />
              {isSymbolFocus && recentSymbolSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentSymbolSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'symbol')} />
              </div>}
            </div>
          </div>

          }

          {!isFilterOpen && <div className={styles.collapsedContainer}>

            {this.state.symbol && <span className={styles.field}>
              <Label title='Symbol: ' isInline /> {this.state.symbol}
            </span>}
            {this.state.systemType && <span className={styles.field}>
              <Label title='System: ' isInline /> {this.state.systemType}
            </span>}
          </div>}

          <div className={styles.controls}>
            {isFilterOpen && <Button title='Search' onClick={this.handleSearch} size='extraSmall' />}
            <Button title='Excel' size='extraSmall' inactive={!this.props.isDataLoaded || this.props.isDownloadInactive} onClick={this.handleDownload} />
            {this.props.isDownloadInactive && <span> Downloading...</span>}
            {isFilterOpen && <div className={styles.collapseOption}>
              <CheckBox
                width='100%'
                text='Collapse filters upon search results'
                onValueChanged={this.handleCollapseOption}
                value={this.state.collapseOnSearch}
              />
            </div>}
          </div>
          <div className={styles.errorMessages}>
            {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
          </div>

          <div className={styles.toggle} onClick={this.toggleFilter}>
            {this.state.showFilter && <FaAngleDoubleUp />}
            {!this.state.showFilter && <FaAngleDoubleDown />}
          </div>
        </div>
      </div>
    );
  }
}
export default OrderBookFilter;

OrderBookFilter.propTypes = {
  search: PropTypes.func,
  isDownloadInactive: PropTypes.bool,
  isDataLoaded: PropTypes.bool

};
